export const BYTES_IN_KB = 1024;
export const BYTES_IN_MB = BYTES_IN_KB ** 2;
export const BYTES_IN_GB = BYTES_IN_KB ** 3;
